// Cart and drawer only: never change a product, cart property, or print file.
// Cart properties are untrusted. Load only the existing preview-only endpoint.
const approvedCoverPattern = /^https:\/\/intention-squared-engine\.onrender\.com\/approved-cover\/[A-Za-z0-9_-]{32,1024}\.png$/;
// Preview delivery shares a bounded server slot. Do not burst simultaneous reads.
let pendingCover = Promise.resolve();

class IntentionCartCover extends HTMLElement {
  connectedCallback() {
    if (this.loadingCover) return;
    const url = this.dataset.coverUrl;
    const fallback = this.querySelector('img');
    if (!fallback || !approvedCoverPattern.test(url || '')) return;
    this.loadingCover = true;
    pendingCover = pendingCover.then(() => {
      if (!this.isConnected) return;
      return new Promise(resolve => this.loadPreview(url, fallback, resolve));
    }).catch(() => { this.dataset.coverState = 'fallback'; });
  }

  loadPreview(url, fallback, done) {
    // Retain the default photograph until the personalized preview really loads.
    // Reuse the loaded image, avoiding a second request and any broken-image flash.
    const preview = new Image();
    preview.alt = 'Your approved journal cover';
    preview.className = fallback.className;
    preview.style.cssText = fallback.style.cssText;
    preview.style.objectFit = 'contain';
    preview.style.height = '100%';
    preview.style.width = '100%';
    preview.decoding = 'async';
    preview.referrerPolicy = 'no-referrer';
    const timeout = setTimeout(() => {
      preview.onload = null;
      preview.onerror = null;
      preview.removeAttribute('src');
      this.dataset.coverState = 'fallback';
      done();
    }, 15000);
    const finish = () => { clearTimeout(timeout); done(); };
    preview.onload = () => {
      if (this.isConnected && fallback.parentNode === this) {
        fallback.replaceWith(preview);
        this.dataset.coverState = 'approved';
      }
      finish();
    };
    preview.onerror = () => {
      this.dataset.coverState = 'fallback';
      finish();
    };
    preview.src = url;
  }
}

if (!customElements.get('intention-cart-cover')) {
  customElements.define('intention-cart-cover', IntentionCartCover);
}
